/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=3b8d419a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3b8d419a&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3b8d419a&lang=css"

import exportComponent from "D:\\work\\2025\\yddh\\web\\xsspm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8d419a"]])

export default __exports__